import { REGEX } from "../constants/regex";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { DomainIdentifier } from "./domainService";


function getTermsPolicyElement(formSelector: string, termsPolicyClass: string = 'terms-policy-text'): HTMLElement | null {
    if (!formSelector) return null;
    const form = document.querySelector(formSelector) as HTMLElement;
    if (!form) return null;
    const children = Array.from(form.children);
    return children.find(child => child.classList?.contains(termsPolicyClass)) as HTMLElement || null;
}

export function hideTermsPolicy(formSelector: string, termsPolicyClass: string = 'terms-policy-text') {
    const termsPolicy = getTermsPolicyElement(formSelector, termsPolicyClass);
    if (termsPolicy) {
        termsPolicy.style.display = 'none';
    }
}

export function toggleTermsPolicyBasedOnCountry(formSelector: string, zipCode: string) {
    const termsPolicy = getTermsPolicyElement(formSelector, 'terms-policy-text');
    if (termsPolicy) {
        const countryZip = !REGEX.sendCaPostalCode.test(zipCode || '') ? 'us' : 'ca';
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode();
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        if ((countryZip === 'ca' && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca'))
            || (countryZip === 'ca')
            || ((zipCode === '') && (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca'))) {
            termsPolicy.style.display = 'none'; // Hide for Canada ZIP codes & Canada local
        } 
        else if ((countryZip === 'us' && zipCode !== '') && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca')) {
            termsPolicy.style.display = 'block';
        }
        else {
            termsPolicy.style.display = 'block'; // Show for US ZIP codes
        }
    }
}
